/**
 * Encadeia múltiplas funções em uma única função, onde cada função consome o resultado da anterior.
 *
 * @param fns - Uma sequência de funções que serão executadas em ordem. Cada função deve receber um único argumento e retornar um valor do mesmo tipo.
 * @returns Uma função que recebe um valor inicial e retorna o resultado da aplicação de todas as funções encadeadas sobre esse valor.
 *
 * @example
 * ```typescript
 * const add = (x: number) => x + 1;
 * const multiply = (x: number) => x * 2;
 *
 * const pipedFunction = pipe(add, multiply);
 * console.log(pipedFunction(5)); // Saída: 12
 * ```
 */
export const pipe =
  <T>(...fns: Array<(arg: T) => T>) =>
  (value: T): T => {
    return fns.reduce((acc, fn) => fn(acc), value)
  }
